// @ts-nocheck
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useToast } from 'hooks';
import { API_URL, ATTACHMENT_API } from './apiConfig';
import useStatusConfirm from './useStatusConfirm';

const useSignatureClientConfirmation = () => {
  const { keyParam } = useStatusConfirm();
  const toast = useToast();

  const sigCanvas = useRef(null);
  const [savedSignature, setSavedSignature] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);
  const [signatureId, setSignatureId] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    if (!keyParam) {
      setErrorMessage('Key parameter is missing.');
    }
  }, [keyParam]);

  const toggleSignaturePad = () => {
    setIsDialogOpen(true);
  };

  // SIGNATURE SAVING
  const saveSignature = async () => {
    if (!sigCanvas.current.isEmpty()) {
      setIsSignatureLoading(true);
      try {
        const signatureDataURL = sigCanvas.current
          .getTrimmedCanvas()
          .toDataURL('image/png');

        const data = {
          file: signatureDataURL,
          key: keyParam,
        };

        const response = await axios.post(`${API_URL}${ATTACHMENT_API}`, data);

        setSavedSignature(response.data.data);
        setSignatureId(response.data.data.id);
        setIsDialogOpen(false);
        toast.success('Signature saved successfully');
      } catch (error) {
        setErrorMessage('Failed to save signature. Please try again.');
      } finally {
        setIsSignatureLoading(false);
      }
    } else {
      setErrorMessage('Please add a signature before saving.');
    }
  };

  // CLEAR
  const clear = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };

  // REMOVE SIGNATURE
  const removeSignature = () => {
    setSavedSignature(null);
  };

  return {
    saveSignature,
    isSignatureLoading,
    savedSignature,
    errorMessage,
    sigCanvas,
    clear,
    removeSignature,
    signatureId,
    isDialogOpen,
    setIsDialogOpen,
    toggleSignaturePad,
  };
};

export default useSignatureClientConfirmation;
